import React, { useEffect, useState } from "react";
import {
    Card, CardBody, Col, Form, Row,
    Input, Label, Button, Spinner
} from "reactstrap";
import Select from "react-select";
import swal from "sweetalert";
import { useNavigate, useSearchParams } from "react-router-dom";

import {
    _Get, _PostSave, _Put, CreateCustomerList, ViewCompanyDetails
} from "../../ApiEndPoint/ApiCalling";

import {
    Create_Receipt,
    Update_Receipt_By_Id,
    View_Receipt_By_Id,
    View_Expense_Account,
    Create_Account_List
} from "../../ApiEndPoint/Api";
import axiosConfig from "../../AxiosConfig"
export default function CreateReceipt() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [bankList, setBankList] = useState([]);
    const view = searchParams.get("view");
    const id = view?.split("-")[2]; // 🔥 extract id

    const [formValues, setFormValues] = useState([
        {
            date: "",
            paymentMode: "",
            type: "receipt",
        },
    ]);

    const [partyList, setPartyList] = useState([]);
    const [loading, setLoading] = useState(false);

    const isEdit = id && id !== "0";
//     useEffect(() => {
//         const fetchBanks = async () => {
//             const user = JSON.parse(localStorage.getItem("userData"));
//             const res = await ViewCompanyDetails(user?._id, user?.database);

//             const banks = res?.CompanyDetail?.bankDetails || [];

//             setBankList(
//                 banks.map((b) => ({
//                     label: b.bankName,
//                     value: b._id,
//                 }))
//             );
//         };

//         fetchBanks();
//     }, []);
    useEffect(() => {
        const fetchParticularData = async () => {
            try {
                const user = JSON.parse(localStorage.getItem("userData"));
                let url = `${Create_Account_List + user?._id}/`;

                const [cust, users, expenses] = await Promise.all([
                    CreateCustomerList(user?._id, user?.database),
                    _Get(url, user?.database),
                    _Get(View_Expense_Account, user?.database),
                ]);

                // Party
                let customer = cust?.Customer?.map((e) => ({
                    label: e.CompanyName,
                    value: e._id,
                    type: "party",
                })) || [];

                // User
                let userList = users?.adminDetails?.map((e) => ({
                    label: e.firstName,
                    value: e._id,
                    type: "user",
                })) || [];

                // Expense
                let expenseList = expenses?.Expenses?.map((e) => ({
                    label: `${e.title} (${e.type})`,
                    value: e._id,
                    type: "expense",
                })) || [];

                setPartyList([...customer, ...userList, ...expenseList]);

            } catch (err) {
                console.log(err);
                swal("Error loading particulars");
            }
        };

        fetchParticularData();
    }, []);
    // 🔥 Load Edit Data
 useEffect(() => {
  if (!isEdit || !id) return;

  const fetchReceiptById = async () => {
    try {
      setLoading(true);

      const res = await axiosConfig.get(
        `/receipt/view-receipt-by-id/${id}`
      );

      console.log("RECEIPT EDIT RESPONSE =>", res?.data);

      const d = res?.data?.Receipts;

      if (!d) {
        swal("Error", "Receipt data not found!", "error");
        return;
      }

      const updatedForm = {
        date: d?.date ? d.date.split("T")[0] : "",
        paymentMode: d?.paymentMode || "",
        amount: d?.amount || "",
        remark: d?.remark || "",
        type: "receipt",
      };

      if (d?.partyId?._id) {
        updatedForm.partyId = d.partyId._id;
      } else if (d?.userId?._id) {
        updatedForm.userId = d.userId._id;
      } else if (d?.expenseId?._id) {
        updatedForm.expenseId = d.expenseId._id;
      }

      if (d?.bankId?._id) {
        updatedForm.bankId = d.bankId._id;
      } else if (d?.bankId) {
        updatedForm.bankId = d.bankId;
      }

      console.log("EDIT FORM =>", updatedForm);

      setFormValues([updatedForm]);
    } catch (err) {
      console.log("GET RECEIPT ERROR =>", err);
      swal("Error", "Error loading receipt!", "error");
    } finally {
      setLoading(false);
    }
  };

  fetchReceiptById();
}, [isEdit, id]);

    // 🔥 Submit
//    const handleSubmit = async (e) => {
//   e.preventDefault();

//   const user = JSON.parse(localStorage.getItem("userData"));

//   const payload = {
//     Receipt: formValues.map((item) => ({
//       ...item,
//       bankId: item.bankId || null,
//     })),
//     created_by: user?._id,
//     database: user?.database,
//   };

//   try {
//     setLoading(true);

//     if (!isEdit) {
//       await _PostSave(Create_Receipt, payload);

//       await swal(
//         "Receipt Created",
//         "Receipt created successfully!",
//         "success"
//       );
//     } else {
//       await _Put(
//         Update_Receipt_By_Id,
//         id,
//         payload.Receipt[0]
//       );

//       await swal(
//         "Receipt Updated",
//         "Receipt updated successfully!",
//         "success"
//       );
//     }

//     // OK click karne ke baad yahan aayega
//     navigate("/transactions?view=receipts");

//   } catch (err) {
//     console.log("Receipt Error =>", err);

//     await swal(
//       "Error",
//       "Something went wrong!",
//       "error"
//     );
//   } finally {
//     setLoading(false);
//   }
// };

const handleSubmit = async (e) => {
  e.preventDefault();

  const user = JSON.parse(localStorage.getItem("userData"));

  const receiptData = formValues.map((item) => {
    const receipt = {
      date: item.date,
      paymentMode: item.paymentMode,
      amount: item.amount,
      remark: item.remark,
      type: "receipt",
      bankId: item.bankId || null,
    };

    // Sirf jiski value hai wahi field payload me jayegi
    if (item.partyId) {
      receipt.partyId = item.partyId;
    }

    if (item.userId) {
      receipt.userId = item.userId;
    }

    if (item.expenseId) {
      receipt.expenseId = item.expenseId;
    }

    return receipt;
  });

  const payload = {
    Receipt: receiptData,
    created_by: user?._id,
    database: user?.database,
  };
  try {
    setLoading(true);

    if (!isEdit) {
      await _PostSave(Create_Receipt, payload);

      await swal(
        "Receipt Created",
        "Receipt created successfully!",
        "success"
      );
    } else {
      await _Put(
        Update_Receipt_By_Id,
        id,
        payload.Receipt[0]
      );

      await swal(
        "Receipt Updated",
        "Receipt updated successfully!",
        "success"
      );
    }

    navigate("/transactions?view=receipts");

  } catch (err) {
    console.log("Receipt Error =>", err);

    await swal(
      "Error",
      "Something went wrong!",
      "error"
    );
  } finally {
    setLoading(false);
  }
};


    return (
        <div className="erp-page-grid">

            <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
            }}>
                <h2>{isEdit ? "Edit Receipt" : "Add Receipt"}</h2>

                <Button
                    onClick={() => navigate("/transactions?view=receipts")}
                    style={{
                        padding: "4px 10px",
                        fontSize: "12px"
                    }}
                >
                    ← Back
                </Button>
            </div>

            <Card>
                <CardBody>
                    <Form onSubmit={handleSubmit}>

                        <Row>
                            <Col md="3">
                                <Label>Date</Label>
                                <Input
                                    type="date"
                                    value={formValues[0].date}
                                    onChange={(e) =>
                                        setFormValues([{ ...formValues[0], date: e.target.value }])
                                    }
                                />
                            </Col>
                            <Col md="3">
                                <Label>Particular</Label>
                               <Select
  options={partyList}
  value={
    partyList.find(
      (option) =>
        option.value === formValues[0]?.partyId ||
        option.value === formValues[0]?.userId ||
        option.value === formValues[0]?.expenseId
    ) || null
  }
  onChange={(selected) => {
    const updated = {
      ...formValues[0],
    };

    // Purani particular ID remove
    delete updated.partyId;
    delete updated.userId;
    delete updated.expenseId;

    if (!selected) {
      setFormValues([updated]);
      return;
    }

    if (selected.type === "party") {
      updated.partyId = selected.value;
    } else if (selected.type === "user") {
      updated.userId = selected.value;
    } else if (selected.type === "expense") {
      updated.expenseId = selected.value;
    }

    setFormValues([updated]);
  }}
  placeholder="Select Particular"
/>
                            </Col>
                            <Col md="3">
                                <Label>Payment Mode</Label>
                                <Input
                                    type="select"
                                    value={formValues[0].paymentMode}
                                    onChange={(e) => {
                                        const mode = e.target.value;

                                        setFormValues([
                                            {
                                                ...formValues[0],
                                                paymentMode: mode,
                                                bankId: mode === "Bank" ? formValues[0].bankId : null,
                                            },
                                        ]);
                                    }}
                                >
                                    <option value="">Select</option>
                                    <option>Cash</option>
                                    <option>Bank</option>
                                </Input>
                            </Col>
                            {formValues[0].paymentMode === "Bank" && (
                                <Col md="3">
                                    <Label>Select Bank</Label>
                                    <Select
                                        options={bankList}
                                        value={bankList.find(
                                            (b) => b.value === formValues[0].bankId
                                        )}
                                        onChange={(selected) =>
                                            setFormValues([
                                                { ...formValues[0], bankId: selected.value },
                                            ])
                                        }
                                    />
                                </Col>
                            )}
                            <Col md="3">
                                <Label>Amount</Label>
                                <Input
                                    type="number"
                                    value={formValues[0].amount}
                                    onChange={(e) =>
                                        setFormValues([{ ...formValues[0], amount: e.target.value }])
                                    }
                                />
                            </Col>

                            <Col md="3">
                                <Label>Remark</Label>
                                <Input
                                    value={formValues[0].remark}
                                    onChange={(e) =>
                                        setFormValues([{ ...formValues[0], remark: e.target.value }])
                                    }
                                />
                            </Col>
                        </Row>

                        <div style={{ marginTop: "20px" }}>
                            <Button color="primary" type="submit" disabled={loading}>
                                {loading ? "Saving..." : "Save"}
                            </Button>
                        </div>

                    </Form>
                </CardBody>
            </Card>
        </div>
    );
}